import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { ChangePasswordComponent } from './modules/change-password/change-password.component';
import { AuthGuard } from './services/Auth/auth.guard';
import { LoginComponent } from './modules/login/login.component';
import { ForgetPasswordComponent } from './modules/forget-password/forget-password.component';
import { ResetPasswordComponent } from './modules/reset-password/reset-password.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { UnderConstructionComponent } from './common/under-construction/under-construction.component';

const routes: Routes = [
  // Public Routes (No AuthGuard)
  { path: '', component: LoginComponent },
  { path: 'admin/forget-password', component: ForgetPasswordComponent },
  { path: 'admin/reset-password/:token', component: ResetPasswordComponent },
  {
    path: 'under-construction',
    component: UnderConstructionComponent,
    canActivate: [AuthGuard]
  },

  // Protected Routes (With AuthGuard)
  {
    path: 'admin',
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'customer-details/:id', component: CustomerDetailsComponent },
      { path: 'change-password', component: ChangePasswordComponent },

      {
        path: "roles",
        loadChildren: () => import('./modules/roles/roles.module').then(m => m.RolesModule)
      },
      {
        path: "users",
        loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule)
      },
      {
        path: "agent",
        loadChildren: () => import('./modules/agent/agent.module').then(m => m.AgentModule)
      },
      {
        path: "agent-customers",
        loadChildren: () => import('./modules/agent-customers/agent-customers.module').then(m => m.AgentCustomersModule)
      },
      {
        path: "agent-leads",
        loadChildren: () => import('./modules/agent-lead/agent-lead.module').then(m => m.AgentLeadModule)
      },
      {
        path: "agent-quote",
        loadChildren: () => import('./modules/agent-quote/agent-quote.module').then(m => m.AgentQuoteModule)
      },
      {
        path: "agent-policies",
        loadChildren: () => import('./modules/agent-policies/agent-policies.module').then(m => m.AgentPoliciesModule)
      },
      {
        path: "agent-commision",
        loadChildren: () => import('./modules/agent-commision/agent-commision.module').then(m => m.AgentCommisionModule)
      },
      {
        path: "departments",
        loadChildren: () => import('./modules/departments/departments.module').then(m => m.DepartmentsModule)
      },
      {
        path: "commission",
        loadChildren: () => import('./modules/commission/commission/commission.module').then(m => m.CommissionModule)
      },
      {
        path: "cms",
        loadChildren: () => import('./modules/cms/cms.module').then(m => m.CMSModule)
      },
      {
        path: "faq",
        loadChildren: () => import('./modules/faq/faq.module').then(m => m.FaqModule)
      },
      {
        path: "insurance-category",
        loadChildren: () => import('./modules/insurance-category/insurence-category.module').then(m => m.InsurenceCaregoryModule)
      },
      {
        path: "company",
        loadChildren: () => import('./modules/company/company.module').then(m => m.CompanyModule)
      },
      {
        path: "documents",
        loadChildren: () => import('./modules/documents/document.module').then(m => m.DocumentModule)
      },
      {
        path: "vehicle",
        loadChildren: () => import('./modules/vehicle/vehicle.module').then(m => m.VehicleModule)
      },
      {
        path: "blog",
        loadChildren: () => import('./modules/blog/blog.module').then(m => m.BlogModule)
      },
      {
        path: "policy-management",
        loadChildren: () => import('./modules/policy-management/policyManagement.module').then(m => m.PolicyManagementModule)
      },
      {
        path: "product-management",
        loadChildren: () => import('./modules/product-management/productManagement.module').then(m => m.ProductManagementModule)
      },
      {
        path: "module-management",
        loadChildren: () => import('./modules/module-management/ModuleManagement.module').then(m => m.ModuleManagementModule)
      },
      {
        path: "claim-management",
        loadChildren: () => import('./modules/claim/claim.module').then(m => m.ClaimModule)
      },
      {
        path: "inspection",
        loadChildren: () => import('./modules/inspection/inspection.module').then(m => m.InspectionModule)
      },
      {
        path: "customer",
        loadChildren: () => import('./modules/customer/customer.module').then(m => m.CustomerModule)
      },
      {
        path: "quote",
        loadChildren: () => import('./modules/quote-management/quote.module').then(m => m.quoteModule)
      },
      {
        path: "transaction",
        loadChildren: () => import('./modules/transaction-management/transaction.module').then(m => m.transactionModule)
      },
      {
        path: "report",
        loadChildren: () => import('./modules/report-management/report.module').then(m => m.ReportModule)
      },
      {
        path: "tax-management",
        loadChildren: () => import('./modules/tax-management/tax.module').then(m => m.TaxModule)
      },
      {
        path: "templates-management",
        loadChildren: () => import('./modules/templates-management/templates.module').then(m => m.TemplatesModule)
      },
      {
        path: ':path',
        component: UnderConstructionComponent
      },
      {
        path: ':path/:id',
        component: UnderConstructionComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
